module.exports = __webpack_public_path__ + "peng_login_admin.png?3d6ecb426cc15affcce2fc194611004c";